const HOST = 'http://localhost';
// const HOST = 'https://raspadinhadigital.quantictechnology.com.br';
const PORT = 4000;

const config = {
  HOST,
  PORT,
};

export default config;